export const useDownloadResume = () => {
    const downloadResume = () => {
        const link = document.createElement("a");
        link.href = "/pdf/Doaa_Ali_El-Sayed_Resume.pdf";
        link.download = "Doaa_Ali_El-Sayed_Resume.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return { downloadResume };
};
